import React from 'react';

import './App.css';
import { Provider } from 'react-redux';
// import { Route, Routes, HashRouter as Router } from "react-router-dom";
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { ThemeProvider } from 'styled-components';

import { store, history } from './configureStore'; // história už nie je potrebná
import NewLayout from './layout';
import ErrorBoundary from './layout/components/errorBoundary';
import './scss/style.scss';
import { AccessControl } from './routes/AccessControl';
import { IRouteRule, RouteRule } from './routes/RouteManager';
import theme from './themeStyled';

const PageNotFound = React.lazy(() => import('./pages/page404/Page404'));

export const App = (): JSX.Element => {
	return (
		<ThemeProvider theme={theme}>
			<Provider store={store}>
				<ToastContainer autoClose={5000} closeOnClick hideProgressBar={false} newestOnTop pauseOnFocusLoss pauseOnHover position='top-right' rtl={false} />
				<Router history={history}>
					<NewLayout>
						<ErrorBoundary>
							<Routes>
								<Route element={<React.Suspense fallback={<>...</>}>{<PageNotFound />}</React.Suspense>} path='*' />
								{Object.values(RouteRule).map((rule: IRouteRule, index: number) => {
									return <Route element={<AccessControl key={index} rule={rule} />} key={index} path={rule.path} />;
								})}
							</Routes>
						</ErrorBoundary>
					</NewLayout>
				</Router>
			</Provider>
		</ThemeProvider>
	);
};
export default App;
